import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;
  
  // Get current tab from URL parameters
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab');

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          IMO Sprint Program
        </Link>
        
        {user && (
          <ul className="navbar-nav">
            {/* Student Dashboard - Always visible for non-admin users */}
            {user.role !== 'admin' && user.role !== 'super-admin' && user.role !== 'teacher' && (
              <li>
                <Link 
                  to="/dashboard?tab=student" 
                  className={`nav-link ${(isActive('/') || (isActive('/dashboard') && (!currentTab || currentTab === 'student'))) ? 'active' : ''}`}
                >
                  📚 Student
                </Link>
              </li>
            )}
            
            {/* Grader Dashboard - Only for users with grader permissions */}
            {(user.role === 'grader' || user.role === 'admin' || user.role === 'super-admin' || user.permissions?.includes('submissions:grade')) && (
              <li>
                <Link 
                  to="/dashboard?tab=grader" 
                  className={`nav-link ${isActive('/dashboard') && currentTab === 'grader' ? 'active' : ''}`}
                >
                  📝 Grader
                </Link>
              </li>
            )}
            
            {/* Admin Dashboard - Only for admin and super-admin users */}
            {(user.role === 'admin' || user.role === 'super-admin') && (
              <li>
                <Link 
                  to="/admin" 
                  className={`nav-link ${isActive('/admin') ? 'active' : ''}`}
                >
                  👨‍💼 Admin 
                </Link>
              </li>
            )}
            
            <li>
              <Link 
                to="/profile" 
                className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
              >
                👤 Profile
              </Link>
            </li>
            
            {user.role === 'admin' && (
              <>
                <li>
                  <Link 
                    to="/admin/create-test" 
                    className={`nav-link ${isActive('/admin/create-test') ? 'active' : ''}`}
                  >
                    Create Test
                  </Link>
                </li>
              </>
            )}
            
            <li>
              <span className="nav-link">
                Welcome, {user.name}
                {user.studentId && (
                  <span className="badge badge-secondary" style={{ marginLeft: '8px' }}>
                    ID: {user.studentId}
                  </span>
                )}
                {user.role === 'super-admin' && (
                  <span className="badge" style={{ marginLeft: '8px', backgroundColor: '#9c27b0', color: 'white' }}>
                    🛡️ Super Admin
                  </span>
                )}
                {user.role === 'admin' && (
                  <span className="badge badge-success" style={{ marginLeft: '8px' }}>
                    👨‍💼 Admin
                  </span>
                )}
                {user.role === 'teacher' && (
                  <span className="badge badge-info" style={{ marginLeft: '8px' }}>
                    👩‍🏫 Teacher
                  </span>
                )}
                {user.role === 'grader' && (
                  <span className="badge badge-warning" style={{ marginLeft: '8px' }}>
                    🎓 Grader
                  </span>
                )}
                {user.role === 'student' && (
                  <span className="badge" style={{ marginLeft: '8px', backgroundColor: '#4caf50', color: 'white' }}>
                    📚 Student
                  </span>
                )}
              </span>
            </li>
            
            <li>
              <button 
                onClick={handleLogout} 
                className="btn btn-outline"
                style={{ padding: '8px 16px', fontSize: '14px' }}
              >
                Logout
              </button>
            </li>
          </ul>
        )}
        
        {!user && (
          <ul className="navbar-nav">
            <li>
              <Link 
                to="/" 
                className={`nav-link ${isActive('/') ? 'active' : ''}`}
              >
                🏠 Home
              </Link>
            </li>
            <li>
              <Link 
                to="/login" 
                className={`nav-link ${isActive('/login') ? 'active' : ''}`}
              >
                Login
              </Link>
            </li>
            <li>
              <Link 
                to="/register" 
                className={`nav-link ${isActive('/register') ? 'active' : ''}`}
              >
                Register
              </Link>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
